var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('time',{attrs:{"datetime":_vm.isoDatetime,"title":_vm.titleValue}},[_vm._v(_vm._s(_vm.timeago))])
}
var staticRenderFns = []

export { render, staticRenderFns }